export default "__VITE_ASSET__D1O442qT__"